import type {CopilotAnnotations} from '@github-ui/copilot-chat-types'
import {createContext} from 'react'

interface ExtensionContext {
  isStreaming?: boolean
  chatMode?: 'assistive' | 'immersive'
  copilotAnnotations?: CopilotAnnotations
  wrapCodeLines?: boolean
  onWrapCodeLinesChange?: (wrap: boolean) => void
  /**
   * Called when the user activates a clickable action in rendered markdown, such as the PR reviewer "Want me to…"
   * suggestions or a review item's "draft PR comment" button. For a suggestion this receives the suggestion's
   * markdown source (inline formatting like `code` and links is preserved); for a review-comment action it
   * receives a short message asking the model to turn that review point into a PR comment (the detailed drafting
   * protocol lives in the copilot-chat `pr-review-comment` ability the model loads). `submit` is true for a normal
   * click (send the text immediately) and false when the user holds Alt/Option (pre-fill the chat input without
   * sending). When omitted, these actions render as plain content.
   */
  onSuggestionSelect?: (suggestionText: string, options: {submit: boolean}) => void
}

/**
 * Shared context for React blocks to get state.
 */
export const ExtensionContext = createContext<ExtensionContext>({})
